import { render, staticRenderFns } from "./VAddBulkCostModal.vue?vue&type=template&id=a29355ae&scoped=true"
import script from "./VAddBulkCostModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAddBulkCostModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VAddBulkCostModal.vue?vue&type=style&index=0&id=a29355ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29355ae",
  null
  
)

export default component.exports